import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import {
  TabContent, TabPane, Nav, NavItem, NavLink,
} from 'reactstrap';
import OneClickButton from '../../../../../components/form/button';
import addNotification from '../../../../../components/notification';
import Form from '../../../../../components/form/form';

import ROUTES from '../../../../../config/routes';

import {
  updateBranchSettings,
  getBranchSettings,
} from '../../../../../app/store/actions/branches';
import DynamicHeadersTable from './dynamicHeadersTable';
import {
  Panel,
  PanelHeader,
  PanelBody,
  PanelFooter,
} from '../../../../../components/panel/panel';

class BranchForm extends React.PureComponent {
  constructor(props) {
    super(props);

    this.defaultErpEndpoints = {
      cancelInboundOrder: '',
      cancelOutboundOrder: '',
      confirmPicking: '',
      confirmPickingProduction: '',
      confirmDevolutionPicking: '',
      getStockBalance: '',
      inboundProductStorage: '',
      industryInvoice: '',
      productsMeasures: '',
      serialLabel: '',
      stockAdjustment: '',
      stockAdjustmentInv: '',
      stockMirror: '',
      waybills: '',
    };

    this.state = {
      disableCode: true,
      disableName: true,
      disableCompany: true,
      showUpdate: false,
      showCancel: false,
      code: '',
      name: '',
      company: '',
      urlErp: '',
      userUrlErp: '',
      passUrlErp: '',
      integrationType: 'TotvsV2',
      headerKey: '',
      headerValue: '',
      dynamicHeaders: [{ type: 'Header', headerKey: '', headerValue: '' }],
      activeTab: 'main',
      erpEndpoints: this.defaultErpEndpoints,
    };

    this.optionsIntegrationType = [
      { label: 'TotvsV2', value: 'TotvsV2' },
      { label: 'TotvsV1', value: 'TotvsV1' },
      { label: 'Zucchetti DebX', value: 'DebX' },
      { label: 'Transis Software', value: 'Transis' },
      { label: 'WTTI Sistemas', value: 'WTTI' },
      { label: 'Sankhya', value: 'Sankhya' },
      { label: 'Prosyst', value: 'Prosyst' },
    ];
  }

  async componentDidMount() {
    const mode = await this.setMode();

    if (mode !== 'create') {
      await this.getBranchSettingsSelected();
    }

    this.setState((state) => ({
      integrationType: state.integrationType || 'TotvsV2',
    }));
  }

  getBranchSettingsSelected = async () => {
    if (this.props.location.state.branch) {
      const { branch } = this.props.location.state;

      const branchSettingsSelected = await this.props.getBranchSettings(
        branch.id,
      );

      if (branchSettingsSelected) {
        this.setState({
          code: branchSettingsSelected.code,
          name: branchSettingsSelected.name,
          company: branchSettingsSelected.company,
          urlErp: branchSettingsSelected.urlErp,
          userUrlErp: branchSettingsSelected.userUrlErp,
          passUrlErp: branchSettingsSelected.passUrlErp,
          integrationType: branchSettingsSelected.integrationType,
          headerKey: branchSettingsSelected.headerKey,
          headerValue: branchSettingsSelected.headerValue,
          dynamicHeaders: branchSettingsSelected.dynamicHeaders
            ? JSON.parse(branchSettingsSelected.dynamicHeaders)
            : [{ type: 'Header', headerKey: '', headerValue: '' }],
          erpEndpoints: branchSettingsSelected.erpEndpoints
            ? branchSettingsSelected.erpEndpoints
            : this.defaultErpEndpoints,
        });
      }
    }
  };

  // Forcando edit, mas para futuras implementacoes ou permissoes, o metodo ja estaram disponivel para alteracao
  setMode = () => {
    const mode = 'edit';

    if (mode === 'edit') {
      this.setState({
        disableCode: true,
        disableName: true,
        disableCompany: true,
        showUpdate: true,
        showCancel: true,
        code: '',
        name: '',
        company: '',
        urlErp: '',
        userUrlErp: '',
        passUrlErp: '',
        integrationType: '',
        headerKey: '',
        headerValue: '',
        dynamicHeaders: [{ type: 'Header', headerKey: '', headerValue: '' }],
        erpEndpoints: this.defaultErpEndpoints,
      });
    }

    return mode;
  };

  setValue = async (attr, value) => {
    this.setState({
      [`${attr}`]: value,
    });
  };

  setErpEndpointValue = (attr, value) => {
    this.setState((prevState) => {
      let endpoints = prevState.erpEndpoints;

      if (Array.isArray(endpoints)) {
        endpoints = endpoints.reduce((acc, cur) => ({ ...acc, ...cur }), {});
      }

      return {
        erpEndpoints: {
          ...endpoints,
          [attr]: value,
        },
      };
    });
  };

  setHeaders = async (dynamicHeaders) => {
    this.setState({
      dynamicHeaders,
    });
  };

  updateBranchSettingsSubmit = async () => {
    const {
      code,
      urlErp,
      userUrlErp,
      passUrlErp,
      integrationType,
      headerKey,
      headerValue,
      dynamicHeaders,
      erpEndpoints,
    } = this.state;

    const filteredDynamicHeaders = dynamicHeaders.filter(
      ({ headerKey, headerValue }) => headerKey.trim() !== '' || headerValue.trim() !== '',
    );

    try {
      const updBranch = await this.props.updateBranchSettings({
        branchCode: code,
        urlErp,
        userUrlErp,
        passUrlErp,
        integrationType,
        headerKey,
        headerValue,
        dynamicHeaders: filteredDynamicHeaders,
        erpEndpoints,
      });

      if (updBranch) {
        addNotification(
          'success',
          I18n.t('BEE148' /* Atualizar Filial */),
          I18n.t(
            'BEE149',
            { 0: code }, /* Atualização da Filial %{0} efetuada com sucesso! */
          ),
          'top-right',
        );

        this.props.history.push(ROUTES.BRANCH_LIST);
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          addNotification(
            'danger',
            I18n.t('BEE148' /* Atualizar Filial */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          addNotification(
            'danger',
            I18n.t('BEE148' /* Atualizar Filial */),
            I18n.t(
              'BEE150',
              { 0: code }, /* Erro ao atualizar a Filial %{0}! */
            ),
            'top-right',
          );
        }
      } else {
        addNotification(
          'danger',
          I18n.t('BEE148' /* Atualizar Filial */),
          I18n.t('BEE150', { 0: code } /* Erro ao atualizar a Filial %{0}! */),
          'top-right',
        );
      }
    }
  };

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  renderDynamicFields = (formContext) => {
    const {
      integrationType, headerKey, headerValue, dynamicHeaders,
    } = this.state;

    switch (integrationType) {
      case 'TotvsV1':
      case 'TotvsV2':
      case 'DebX':
      case 'Transis':
      case 'WTTI':
        return [
          formContext.createInput(
            headerKey,
            'headerKey',
            `${I18n.t('BEE4221' /* Cabeçalho (Chave) */)}:`,
            '',
            'text',
            false,
          ),
          formContext.createInput(
            headerValue,
            'headerValue',
            `${I18n.t('BEE4222' /* Cabeçalho (Valor) */)}:`,
            '',
            'text',
            false,
          ),
        ];
      case 'Sankhya':
        return [
          <DynamicHeadersTable
            rows={dynamicHeaders}
            setHeaders={this.setHeaders}
          />,
        ];
      default:
        return [];
    }
  };

  render() {
    const { code, name, company } = this.state;

    const {
      disableCode,
      disableName,
      disableCompany,
      showUpdate,
      showCancel,
      urlErp,
      userUrlErp,
      passUrlErp,
      integrationType,
      erpEndpoints,
    } = this.state;

    const title = I18n.t('BEE439' /* Parâmetros */);

    const breadActive = `${code} - ${name}`;

    return (
      <div className="slideUpTransition">
        <div className="d-flex align-items-center">
          <ol className="breadcrumb float-xl-left">
            <li className="breadcrumb-item">
              <i className="fas fa-home fa-fw m-t-10 m-r-5" />
              {I18n.t('BEE12' /* Início */)}
            </li>
            <li className="breadcrumb-item">
              {I18n.t('BEE13' /* Administração */)}
            </li>
            <li className="breadcrumb-item">{I18n.t('BEE14' /* Gerais */)}</li>
            <li className="breadcrumb-item">{I18n.t('BEE16' /* Filiais */)}</li>
            <li className="breadcrumb-item active">{breadActive}</li>
          </ol>
        </div>
        <div className="d-flex align-items-center mb-md-3 mb-2">
          <h1 className="page-header mb-0">{title}</h1>
        </div>
        <div className="row">
          <div className="col-xl-12 text-right">
            <form onSubmit={(e) => e.preventDefault()}>
              <Panel>
                <PanelHeader noButton />
                <PanelBody>
                  <div className="row">
                    <div className="col mb-3">
                      <Nav
                        tabs
                        justified
                        fill
                        style={{ backgroundColor: 'lightgray' }}
                      >
                        <NavItem>
                          <NavLink
                            className={
                              this.state.activeTab === 'main' ? 'active' : ''
                            }
                            onClick={() => {
                              this.toggleTab('main');
                            }}
                          >
                            {I18n.t('BEE191' /* Geral */)}
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={
                              this.state.activeTab === 'endpoints'
                                ? 'active'
                                : ''
                            }
                            onClick={() => {
                              this.toggleTab('endpoints');
                            }}
                          >
                            {I18n.t('BEE4456' /* Endpoints ERP */)}
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <TabContent activeTab={this.state.activeTab}>
                        <TabPane tabId="main">
                          <Form
                            noPanel
                            noButton
                            setValue={this.setValue}
                            inputs={(formContext) => [
                              formContext.createInput(
                                code,
                                'code',
                                `${I18n.t('BEE82' /* Código */)}:`,
                                I18n.t('BEE1781' /* Informe a filial */),
                                'text',
                                true,
                                disableCode,
                              ),
                              formContext.createInput(
                                name,
                                'name',
                                `${I18n.t('BEE83' /* Nome */)}:`,
                                I18n.t(
                                  'BEE3671', /* Informe o nome da filial */
                                ),
                                'text',
                                true,
                                disableName,
                              ),
                              formContext.createInput(
                                company,
                                'company',
                                `${I18n.t('BEE112' /* Empresa */)}:`,
                                '',
                                'text',
                                false,
                                disableCompany,
                              ),
                              formContext.createInput(
                                urlErp,
                                'urlErp',
                                `${I18n.t(
                                  'BEE2534', /* URL de conexão ERP */
                                )}:`,
                                '',
                                'text',
                                false,
                              ),
                              formContext.createInput(
                                userUrlErp,
                                'userUrlErp',
                                `${I18n.t('BEE2535' /* Usuário ERP */)}:`,
                                '',
                                'text',
                                false,
                              ),
                              formContext.createInput(
                                passUrlErp,
                                'passUrlErp',
                                `${I18n.t('BEE2536' /* Senha ERP */)}:`,
                                '',
                                'password',
                                false,
                              ),
                              formContext.createSelect(
                                integrationType,
                                'integrationType',
                                `${I18n.t(
                                  'BEE3004', /* Tipo de Integração */
                                )}:`,
                                this.optionsIntegrationType,
                                false,
                              ),
                              ...this.renderDynamicFields(formContext),
                            ]}
                          />
                        </TabPane>
                        <TabPane tabId="endpoints">
                          <Form
                            noPanel
                            noButton
                            setValue={this.setErpEndpointValue}
                            inputs={(formContext) => [
                              formContext.createInput(
                                erpEndpoints.cancelInboundOrder,
                                I18n.t('BEE4457' /* cancelInboundOrder */),
                                `${I18n.t('BEE2247' /* Cancela Entrada */)} (${I18n.t(
                                  'BEE4457', /* cancelInboundOrder */
                                )}):`,
                                '',
                                'text',
                                false,
                              ),
                              formContext.createInput(
                                erpEndpoints.cancelOutboundOrder,
                                I18n.t('BEE4458' /* cancelOutboundOrder */),
                                `${I18n.t('BEE2248' /* Cancela Saída */)} (${I18n.t(
                                  'BEE4458', /* cancelOutboundOrder */
                                )}):`,
                                '',
                                'text',
                                false,
                              ),
                              formContext.createInput(
                                erpEndpoints.confirmPicking,
                                I18n.t('BEE4459' /* confirmPicking */),
                                `${I18n.t('BEE2249' /* Confirma Separação */)} (${I18n.t(
                                  'BEE4459', /* confirmPicking */
                                )}):`,
                                '',
                                'text',
                                false,
                              ),
                              formContext.createInput(
                                erpEndpoints.confirmPickingProduction,
                                I18n.t(
                                  'BEE4460', /* confirmPickingProduction */
                                ),
                                `${I18n.t('BEE2921' /* Confirma Separação OP */)} (${I18n.t(
                                  'BEE4460', /* confirmPickingProduction */
                                )}):`,
                                '',
                                'text',
                                false,
                              ),
                              formContext.createInput(
                                erpEndpoints.confirmDevolutionPicking,
                                I18n.t(
                                  'BEE4461', /* confirmDevolutionPicking */
                                ),
                                `${I18n.t('BEE2320' /* Confirma Devolução */)} (${I18n.t(
                                  'BEE4461', /* confirmDevolutionPicking */
                                )}):`,
                                '',
                                'text',
                                false,
                              ),
                              formContext.createInput(
                                erpEndpoints.getStockBalance,
                                I18n.t('BEE4462' /* getStockBalance */),
                                `${I18n.t('BEE2328' /* Comparativo Saldo Estoque */)} (${I18n.t(
                                  'BEE4462', /* getStockBalance */
                                )}):`,
                                '',
                                'text',
                                false,
                              ),
                              formContext.createInput(
                                erpEndpoints.inboundProductStorage,
                                I18n.t('BEE4463' /* inboundProductStorage */),
                                `${I18n.t(
                                  'BEE2250', /* Confirma Recebimento */
                                )} (${I18n.t(
                                  'BEE4463', /* inboundProductStorage */
                                )}):`,
                                '',
                                'text',
                                false,
                              ),
                              formContext.createInput(
                                erpEndpoints.industryInvoice,
                                I18n.t('BEE4464' /* industryInvoice */),
                                `${I18n.t('BEE2874' /* Documento de Saída Industria */)} (${I18n.t(
                                  'BEE4464', /* industryInvoice */
                                )}):`,
                                '',
                                'text',
                                false,
                              ),
                              formContext.createInput(
                                erpEndpoints.productsMeasures,
                                I18n.t('BEE4465' /* productsMeasures */),
                                `${I18n.t('BEE2251' /* Medidas Produto */)} (${I18n.t(
                                  'BEE4465', /* productsMeasures */
                                )}):`,
                                '',
                                'text',
                                false,
                              ),
                              formContext.createInput(
                                erpEndpoints.serialLabel,
                                I18n.t('BEE4466' /* serialLabel */),
                                `${I18n.t('BEE2760' /* Etiqueta Seriada */)} (${I18n.t('BEE4466' /* serialLabel */)}):`,
                                '',
                                'text',
                                false,
                              ),
                              formContext.createInput(
                                erpEndpoints.stockAdjustment,
                                I18n.t('BEE4467' /* stockAdjustment */),
                                `${I18n.t('BEE2815' /* 'Ajuste Estoque'  */)} (${I18n.t(
                                  'BEE4467', /* stockAdjustment */
                                )}):`,
                                '',
                                'text',
                                false,
                              ),
                              formContext.createInput(
                                erpEndpoints.stockAdjustmentInv,
                                I18n.t('BEE4468' /* stockAdjustmentInv */),
                                `${I18n.t('BEE2816' /* Ajuste Inventário */)} (${I18n.t(
                                  'BEE4468', /* stockAdjustmentInv */
                                )}):`,
                                '',
                                'text',
                                false,
                              ),
                              formContext.createInput(
                                erpEndpoints.stockMirror,
                                I18n.t('BEE4469' /* stockMirror */),
                                `${I18n.t('BEE4208' /* Espelho de Estoque */)} (${I18n.t(
                                  'BEE4469', /* stockMirror */
                                )}):`,
                                '',
                                'text',
                                false,
                              ),
                              formContext.createInput(
                                erpEndpoints.waybills,
                                I18n.t('BEE4470' /* waybills */),
                                `${I18n.t('BEE907' /* Romaneio */)} (${I18n.t('BEE4470' /* waybills */)}):`,
                                '',
                                'text',
                                false,
                              ),
                            ]}
                          />
                        </TabPane>
                      </TabContent>
                    </div>
                  </div>
                </PanelBody>
                <PanelFooter>
                  <Link
                    to={{
                      pathname: ROUTES.BRANCH_LIST,
                      state: { dice: this.props.location.dice },
                    }}
                  >
                    {showCancel && (
                      <OneClickButton
                        type="submit"
                        className="btn btn-120 btn-white p-5 m-5"
                      >
                        {I18n.t('BEE99' /* Cancelar */)}
                      </OneClickButton>
                    )}
                  </Link>
                  {showUpdate && (
                    <OneClickButton
                      type="button"
                      className="btn btn-120 btn-primary p-5 m-5"
                      onClick={() => this.updateBranchSettingsSubmit()}
                    >
                      {I18n.t('BEE139' /* Atualizar */)}
                    </OneClickButton>
                  )}
                </PanelFooter>
              </Panel>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  getBranchSettings: (branchId) => dispatch(getBranchSettings(branchId)),
  updateBranchSettings: (branch) => dispatch(updateBranchSettings(branch)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(BranchForm));
